import React, { Component } from "react";
import Transporte from "../Resources/transporte.svg";
import Card from "../Card/Card";
import "./Trenes.css";
import fav from "../Resources/logo-salidas.png";
import trenesamba from "./guion-social-trenes-amba.pdf";
import trenesld from "./guion-social-trenes-larga-distancia.pdf";
import DownloadModal from "../DownloadModal/DownloadModal";

export class Trenes extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isModalOpenAmba: false,
            isModalOpenLD: false,
        };
    }

    handleDownloadAmba = (email) => {
        const element = document.createElement("a");
        element.href = trenesamba;
        element.download = "Guión social en trenes del AMBA.pdf";
        element.click();
        console.log(`Correo registrado para AMBA: ${email}`);
    };

    handleDownloadLD = (email) => {
        const element = document.createElement("a");
        element.href = trenesld;
        element.download = "Guión Social para trenes de larga distancia.pdf";
        element.click();
        console.log(`Correo registrado para Larga Distancia: ${email}`);
    };

    render() {
        return (
            <main className="container-fluid text-center mb-5">
                <div className="row d-flex align-items-center justify-content-center">
                    <a href="/">
                        <img src={fav} width={200} alt=""></img>
                    </a>
                </div>
                <div className="row mt-5">
                    <div className="col-md-12">
                        <h3 className="title">Trenes</h3>
                    </div>
                </div>
                <div className="row mt-5">
                    <div className="col-md-12">
                        <div className="container-transporte d-flex align-items-center justify-content-center bg-container-transporte p-8">
                            <Card
                                svg={Transporte}
                                title={""}
                                width={"100"}
                                height={"100"}
                                maxWidth="1000"
                                animation={false}
                                pagination={false}>
                                <div className="card-body-transporte">
                                    <p>
                                        En el año 2023 trabajamos junto a <strong>Trenes
                                        Argentinos</strong> en el armado de <strong>guiones
                                        sociales</strong> para viajes en AMBA y viajes de
                                        larga distancia. Estos guiones sociales
                                        son herramientas diseñadas para ayudar a
                                        personas neurodivergentes a comprender y
                                        anticipar lo que sucederá en cada etapa
                                        del viaje. Funcionan como una guía
                                        estructurada que explica, de manera
                                        clara y visual, los pasos a seguir antes
                                        de subir al tren, durante el recorrido y
                                        al bajar del mismo hasta salir de la
                                        estación.
                                    </p>
                                    <p>
                                        Esta iniciativa representa un paso
                                        fundamental hacia la accesibilidad en el
                                        sistema ferroviario, permitiendo que más
                                        personas viajen con autonomía y
                                        confianza. Sigamos impulsando espacios
                                        inclusivos donde todos puedan
                                        desplazarse sin barreras.
                                    </p>

                                    <div className="d-flex flex-row flex-wrap justify-content-center">
                                        <button
                                            onClick={() => this.setState({ isModalOpenAmba: true })}
                                            className="btn btn-primary col-md-8 col-6 mx-1"
                                            style={{ minWidth: "260px" }}>
                                            Guión social en trenes del AMBA
                                        </button>
                                    </div>

                                    <div className="d-flex flex-row flex-wrap justify-content-center">
                                        <button
                                            onClick={() => this.setState({ isModalOpenLD: true })}
                                            className="btn btn-primary col-md-8 col-6 mx-1"
                                            style={{ minWidth: "260px" }}>
                                            Guión Social para trenes de larga
                                            distancia
                                        </button>
                                    </div>
                                </div>
                            </Card>
                        </div>
                    </div>
                </div>

                <DownloadModal
                    isOpen={this.state.isModalOpenAmba}
                    onClose={() => this.setState({ isModalOpenAmba: false })}
                    onDownload={this.handleDownloadAmba}
                />

                <DownloadModal
                    isOpen={this.state.isModalOpenLD}
                    onClose={() => this.setState({ isModalOpenLD: false })}
                    onDownload={this.handleDownloadLD}
                />
            </main>
        );
    }
}
